import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_SERVICE_CONFIG } from '@fullyops/legacy/data/index';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiHttpClient {
  readonly http = inject(HttpClient);
  readonly baseUrl = inject(API_SERVICE_CONFIG).url;

  withBasePath(basePath: string) {
    return {
      creator: <T>() => this.creator<T>(basePath),
      attacher: () => this.attacher(basePath),
    };
  }

  allGetter<T>(basePath: string): () => Observable<T[]> {
    return () => this.http.get<T[]>(this.baseUrl + basePath);
  }

  getterById<T>(basePath: string): (id: string) => Observable<T> {
    return (id) => this.http.get<T>(this.baseUrl + basePath + '/' + id);
  }

  creator<T>(basePath: string): (input: T) => Observable<{ id: string }> {
    return (input) =>
      this.http.post<{ id: string }>(this.baseUrl + basePath, input);
  }

  attacher(basePath: string): (id: string, files: File[]) => Observable<void> {
    return (id, files) => {
      if (files.length === 0) {
        return of(null);
      }
      const formData = new FormData();
      for (const f of files) {
        formData.append('file', f);
      }
      return this.http.post<void>(
        this.baseUrl + basePath + '/' + id + '/attachments',
        formData,
      );
    };
  }

  updater<T>(basePath: string): (id: string, input: T) => Observable<void> {
    return (id, input) =>
      this.http.patch<void>(this.baseUrl + basePath + '/' + id, input);
  }

  deleter(basePath: string): (id: string) => Observable<void> {
    return (id) => this.http.delete<void>(this.baseUrl + basePath + '/' + id);
  }
}
